const subFieldsPages = {
	epChildrenDeath: 3,
	epChildrenDeathDisablity:3,
	epChildrenDeathImpairment: 3
};
const ignoreSubFields = ['dummyField'];

export const subFieldsPagesSyncErrors = (syncErrors, page) => {
	Object.keys(subFieldsPages).forEach(f => {
		if (
			syncErrors[f] &&
			page === subFieldsPages[f] &&
			Array.isArray(syncErrors[f])
		) {
			syncErrors[f].forEach((a, i) => {
				ignoreSubFields.forEach(ignore => {
					if (a[ignore]) {
						delete syncErrors[f][i][ignore];
					}
				});
			});

			let emptyIndexes = 0;

			syncErrors[f].forEach(a => {
				if (Object.keys(a).length < 1) emptyIndexes++;
			});

			if (emptyIndexes === syncErrors[f].length) delete syncErrors[f];
		} else {
			delete syncErrors[f];
		}
	});
	return syncErrors;
};



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/objects/syncErrorHelper.js